import React from 'react';
import moment from 'moment';
import { Spin, Avatar, Button, Divider } from 'antd';
import { MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import { LayoutPage } from 'components/layouts';
import { useDocument } from 'react-firebase-hooks/firestore';
import { useUserWithRole } from 'hooks/custom-auth';
import { getAge } from 'utils/functions';
import Client from 'containers/app/client';

import './style.css';

const Profile = () => {
  const [user, userLoading, userError] = useUserWithRole(Client.auth);
  const [profile, profileLoading, profileError] = useDocument(Client.dbProfile());

  if (userLoading || profileLoading) return <Spin />;
  if (userError) throw userError;
  if (profileError) throw profileError;

  const { email, emailVerified, photoURL } = user;

  const {
    info: { dateOfBirth, gender, mobilePhone, firstName, lastName },
  } = profile.data() || {};

  const dOBFormatted = dateOfBirth
    ? moment(dateOfBirth).format('DD-MM-YYYY')
    : undefined;

  const age = dateOfBirth ? getAge(dateOfBirth, moment()) : undefined;
  const fullName = `${firstName} ${lastName}`;

  return (
    <LayoutPage className="profile-page">
      <LayoutPage.Container className="wrapper">
        <header className="worker-detail-header">
          <Avatar src={photoURL} size={150} icon={<UserOutlined />} />

          <h1>{fullName}</h1>

          <div className="worker-detail-actions">
            <Button href={`tel:${mobilePhone}`} icon={<PhoneOutlined />}>
              {mobilePhone}
            </Button>
            <Button icon={<MailOutlined />} href={`mailto:${email}`}>
              {email}
            </Button>
          </div>

          <section className="worker-detail-info">
            <Divider />
            <p>Date Of Birth: {dOBFormatted}</p>
            <p>Age: {age}</p>
            <p>Gender: {gender}</p>
            <p>
              Email status:
              {emailVerified ? ' verified' : ' waiting for verification'}
            </p>
          </section>

          {/* <article>
            <InfoCircleOutlined />
            {title}.
          </article> */}
          {/* <article>
            <InfoCircleOutlined />
            Role: {user.claims.role}
          </article>
          <article>
            <InfoCircleOutlined />
            Admin:{' '}
            {user.claims.admin ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )}
          </article> */}
        </header>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

Profile.propTypes = {};

export default Profile;
